// Ukrainian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `відкрити до ${date}` : ''),
    },
    interview: {
      title: 'Відповісти на відео-співбесіду',
      submit: 'Відправити відповіді та завершити співбесіду',
      continueLater: 'Продовжити пізніше',
      startInterview: 'Розпочати співбесіду',
      duplicateError: 'Ви вже взяли участь у цій співбесіді. На вашу електронну пошту ви отримали лист від invitations@recright.com з посиланням, через яке ви можете продовжити співбесіду.',
      confirmSubmitHeader: 'Ви не відповіли на усі запитання співбесіди',
      confirmSubmitContent: 'Ви справді хочете закінчити співбесіду?',
      confirmSubmitContentWarning: 'Після цього ви не зможете додати відповіді на запитання.',
      submitInterviewHeader: 'Надішліть свої відповіді на співбесіду',
      submitInterviewContent: 'Ви впевнені, що хочете надіслати свої відповіді на співбесіду?',
      confirmSubmitButton: 'Відправити відповіді та завершити співбесіду',
      preview: 'Ви можете переглянути відео-запитання тут.',
      requiredQuestionsNotAnswered: 'Будь ласка, дайте відповідь на всі обов\'язкові питання перед відправленням.',
      withdrawLink: 'Вас більше не цікавить ця посада? Відкликати свою кандидатуру тут.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: "Ім'я",
      city: 'Рідне місто',
      email: 'Електронна пошта',
      phone: 'Телефонний номер',
      link: 'Посилання',
      legendBasicInfo: 'Основна інформація',
      placeholderName: 'Введіть ім\'я',
      placeholderEmail: 'Введіть електронну пошту',
      placeholderPhone: 'Введіть номер телефону',
      placeholderCity: 'Введіть місто, в якому зараз живете',
      placeholderLink: 'Додайте посилання, наприклад, на ваш профіль в LinkedIn.',
      legendAttachments: 'Вкладені файли',
      legendAdditionalFields: 'Додаткова інформація',
      required: 'Пункти, відмічені зірочкою *, є обов\'язковими.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Звук',
        video: 'Відео',
        yes: 'Так',
        no: 'Ні',
        supported: 'Підтримується',
        quality: 'Якість',
        header: 'Тестування підключення до мережі й апаратного забезпечення',
        description: 'Зараз ми проведемо тестування, щоб переконатися, що ваше підключення до мережі й апаратне забезпечення (камера та мікрофон), необхідні для проведення інтерв’ю, працюють належним чином. Коли з’явиться відповідний запит, надайте дозвіл на використання камери й мікрофона для проведення тестування та переконайтеся, що камеру ніщо не затуляє. Тестування триватиме близько 30 секунд. Під час тестування апаратного забезпечення радимо вам сказати щось.',
        inProgress: 'Проводиться тестування…',
        networkTestResults: 'Результати тестування підключення до мережі',
        qualityTestResults: 'Результати тестування якості',
        testPassedQuality: 'Тестування якості пройдено',
        testFailedQuality: 'Тест якості виконано не вдало',
        testPassedNetwork: 'Тест мережі пройдено вдало',
        testFailedNetwork: 'Тестування мережі не пройдено',
        startTest: 'Почати тестування',
        startInterview: 'Почати інтерв’ю',
        testAgain: 'Повторити тестування',
        confirmWarning: 'На початку відеоінтерв\'ю вас автоматично переведуть у режим перегляду першого запитання. Переглянувши запитання, ви перейдете до підготовки.',
        confirmTitle: 'Ви збираєтеся почати інтерв’ю',
        confirmText: 'Час на підготовку відповіді до кожного запитання буде обмеженим. Після підготовки вам буде надано фіксований час для відповіді на кожне запитання. Пам\'ятайте, що ви можете надати відповідь як тільки будете готові, навіть ще до закінчення встановленого часу.',
        confirmText2: 'Після надання відповіді, ви будете переходити до наступного запитання, доки запитання не скінчаться.',
        confirmText3:
          'Зверніть увагу, що після запису вашої відповіді ви матимете 30 секунд, щоб надати іншу відповідь, якщо це дозволено для запитання. Якщо ви не надасте іншу відповідь протягом 30 секунд, вашу поточну відповідь буде автоматично прийнято, і ви перейдете до наступного запитання.',
        goodLuck: 'Зробіть глибокий вдох і розслабтеся. Хай щастить!',
        qualityRating: {
          excellent: 'Відмінно',
          good: 'Добре',
          fair: 'Задовільно',
          poor: 'Незадовільно',
          bad: 'Погано',
        },
      },
      questionAnswerView: {
        title: title => `Відповіді для інтерв’ю ${title}`,
        question: 'Запитання',
        submitAndNext: 'Надіслати й перейти далі',
        submitSuccess: 'Відео успішно надіслано!',
        skipText: 'Почати зйомку',
        stop: 'Стоп',
        submitAndFinish: 'Надіслати та завершити опитування',
        retake: 'Спробувати ще',
        take: 'Пройти опитування',
        takesLeft: 'Залишилося спроб',
        skipTextQuestion: 'Приготувалися? Рухайтеся вперед',
        retakeConfirmTitle: 'Ви впевнені, що хочете надати іншу відповідь на це запитання?',
        retakeConfirmSubmit: 'Так, надати іншу відповідь.',
        submitInfoForward: 'Вашу поточну відповідь буде прийнято автоматично й ви перейдете до наступного запитання.',
        submitInfoForward2: 'с',
        nonAnswerableText: 'Це повідомлення не потребує відповіді. Після цього повідомлення перейдете безпосередньо до наступного запитання.',
        nonAnswerableVideo: 'Це відео не потребує відповіді. Після цього відео перейдете безпосередньо до наступного запитання.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Щоб відповісти на запитання, у вас є ${answerMinutes} хв. і ${answerSeconds} сек.`,
      },
      publisher: {
        toNextQuestion: timer => `Ви перейдете до наступного запитання через ${timer}`,
        recordingStarts: timer => `Зйомка почнеться через ${timer}`,
      },
      errors: {
        tooManyConnections: 'З\'єднання було перервано, оскільки у вас уже відкрите з\'єднання в іншій вкладці або вікні.',
        unsupportedBrowser: 'На жаль, ця операція не підтримується у вашому веб-переглядачі. Скористайтесь іншим веб-переглядачем.',
        networkError: 'Підключення до мережі відсутнє.',
        reconnecting: 'Підключення до мережі перервалося. Ми намагаємося відновити його.',
        generalError: 'Сталася помилка. Оновіть сторінку та повторіть спробу.',
        allowMediaDevicesError: 'Цій операції не вдалось отримати доступ до пристроїв мультимедіа (камери й мікрофона). Переконайтесь, що ви надали веб-переглядачу дозвіл на використання камери та мікрофона.',
        noAvailableDevicesError: 'Камеру чи мікрофон не знайдено.',
        initPublisherError: 'Не вдалося виконати операцію через помилку. Переконайтеся, що ви браузер має дозвіл на використання камери і мікрофона, перевірте, чи не використовуються вони іншим додатком, повторіть спробу.',
      },
      browserInfo: {
        browserSupportTitle: 'Підтримка веб-переглядачів',
        supportedBrowsers: 'Для проходження тесту й інтерв\'ю можна використовувати веб-переглядачі Chrome, Firefox, Safari й Edge останньої версії.',
        mobileSupported: 'Підтримувані мобільні веб-переглядачі',
        android: 'Android: Google Chrome (остання версія), Firefox (остання версія)',
        iOS: 'iOS: Safari (остання версія)',
        latestVersion: 'Переконайтесь, що ви використовуєте останню версію веб-переглядача. Це необхідно для безперебійної роботи.',
        freezeInstruction: 'Якщо запис відео не починається або екран запису залишається чорним, оновіть сторінку.',
        unsupportedOnIos: 'Схоже, що ви використовуєте непідтримуваний веб-переглядач на пристрої iOS. Скористайтеся веб-переглядачем Safari.',
        ieUnsupported: 'Схоже, що ви використовуєте Internet Explorer. На жаль, Internet Explorer неможливо використовувати для проведення цього тестування або інтерв’ю. Скористайтесь іншим веб-переглядачем.',
        qualityTestNotSupported: 'На жаль, тестування апаратного забезпечення недоступне у веб-переглядачі, який ви використовуєте. Ви можете почати інтерв’ю без перевірки якості звуку й відео або скористатись іншим веб-переглядачем.',
      },
      reconnectSuccess: 'Підключення до мережі відновлено',
      continue: 'Продовжити',
    },

    withdraw: {
      title: 'Вас більше не цікавить ця посада?',
      description: 'Відкликати свою кандидатуру на посаду.',
      buttonText: 'Відкликати кандидатуру на посаду.',
      thankYouTitle: 'Дякуємо!',
      thankYouText: 'Ви повідомили рекрутерів, що вас більше не цікавить ця посада.',
      confirm: 'Ви впевнені, що бажаєте відкликати свою кандидатуру? Після відмови, ви більше не зможете брати участь у цій, або будь-якій іншій співбесіді щодо даної посади.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Відправити',
      continue: 'Продовжити',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Дякуємо за ваші відео відповіді! Ми зв\'яжемось з вами найближчим часом!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Дякуємо за вашу участь у співбесіді.',
      reopenDescription: 'Якщо ви випадково закрили інтерв\'ю, не хвилюйтесь! Ви можете відновити інтерв\'ю, натиснувши кнопку нижче!',
      reopenButtonText: 'Відновити інтерв\'ю',
      description1: 'Чудово! Ви відповіли на всі запитання і їх доставлено до отримувача.',
      descriptionsupport: mailto => `Якщо ви помилково закрили цю співбесіду, будь ласка, зв'яжіться з нашим відділом обслуговування клієнтів ${mailto} і ми знову відкриємо вашу співбесіду.`,
      descriptionfeedback: 'Ваш досвід важливий для нас! Поділіться своїм досвідом проходження відео-співбесіди. Поділіться своїми думками щодо покращення наших послуг. Залишіть відгук тут.',
      feedbackbutton: 'Залиште нам свій відгук!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Особисте повідомлення',
    },

    closed: {
      title: 'Співбесіда завершилась або співбесіда закінчилась',
      description: 'Відео-співбесіда, на яку вас запросили, вже завершилась або ви вже завершили ваше подання.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Тепер ваше відео збережене!',
      description: 'Коли ви захочете продовжити відео-співбесіду, перейдіть за посиланням, яке ви раніше отримали на електронну пошту. Відео-відповіді, які ви вже записали, будуть доступні, коли ви повернетесь! Бажаємо успіхів у пошуку роботи!',
      remember: 'Не забудьте надіслати свої відповіді рекрутеру, після того як закінчили відповідати на співбесіді.',
      deleteHistory: 'Якщо ви проходили співбесіду на публічному комп\'ютері, будь ласка, не забудьте очистити історію веб-перегляду. Таким чином, ви переконаєтесь, що ваша співбесіда захищена.',
    },
    unpublished: {
      title: 'Співбесіду ще не відкрито',
      publishTime: publishTime => `Співбесіду буде відкрито в ${publishTime}`,
    },
  },
}
